import { api } from "@/lib/api/api";
import { args } from "@/lib/args/args";
import { expectShape } from "@/lib/expect/expect-shape";
import { is } from "@/lib/is/is";
import { out } from "@/lib/output/out";
import { path } from "@/lib/path/path";
import type { ApiOutputs } from "@/lib/api/api-outputs";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

export async function sendSessionMessage(
  parsed: ParsedArgs,
  asJson: boolean,
): Promise<void> {
  args.expect(parsed, { positional: 3 });
  const sessionId = args.required(parsed, 1, "sessionId");
  const message = args.required(parsed, 2, "message");
  const result = expectShape<ApiOutputs["sessions"]["sendMessage"]>(
    await api(path`/sessions/${sessionId}/messages`, {
      method: "POST",
      body: { message },
    }),
    "POST /sessions/{id}/messages",
    { delivery: is.string },
  );
  if (asJson) {
    out.json(result);
    return;
  }
  out.line(
    result.delivery === "interrupt"
      ? "Delivered to the running agent."
      : "Queued: the agent picks it up at the end of its turn.",
  );
}
